require('../../modules/es6.array.find-index');
module.exports = require('../../modules/_core').Array.findIndex;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/node_modules/core-js/fn/array/find-index.js
// module id = 595
// module chunks = 0